import { useRecoilState, SetterOrUpdater } from 'recoil';
import { aMatrixMemberDirectory, aMatrixOpenRoomId, aMatrixRoomSummaries } from './atoms';
import { IMatrixMemberDirectoryEntry, IMatrixRoomSummary } from './types';

export const useMatrixRoomSummaries = (): [IMatrixRoomSummary[], SetterOrUpdater<IMatrixRoomSummary[]>] => useRecoilState(aMatrixRoomSummaries);
export const useOpenMatrixRoomId = (): [string | null, SetterOrUpdater<string | null>] => useRecoilState(aMatrixOpenRoomId);
export const useMatrixMemberDirectory = (): [IMatrixMemberDirectoryEntry[], SetterOrUpdater<IMatrixMemberDirectoryEntry[]>] =>
    useRecoilState(aMatrixMemberDirectory);
